module.exports = __webpack_public_path__ + "img/pic_banner_exhibition.ced28178.png";